export default function global_variables()
{
    return {
        SINISTRE_CARE_WEBSERVICE: 'https://servo.integralewebservice.com/api',
        // SINISTRE_CARE_WEBSERVICE: 'https://servo.groupensia.com/api',
    }
}
